/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { ProactiveChatNames } from '../../helpers/consts';
import { IExtendedRequest } from '../../interfaces';
import { IChatContext, TContextProvider } from '@msdyn365-commerce-modules/chat';
import { IPvaChatConnectorViewProps } from '../../pva-chat-connector';
import ProactiveChatTrigger from './proactive-chat-trigger';

/**
 * SpecificPageTrigger class - proactive chat is triggered if user geographically uses the website from specific country/regions(config.proactiveOnSpecificCountryRegionCountry)
 */
class SpecificCountryRegionTrigger extends ProactiveChatTrigger {
    private customerCountryCode: string;
    constructor(props: IPvaChatConnectorViewProps, context: IChatContext) {
        super(props, context);
        this.customerCountryCode = (<IExtendedRequest>this.props.context.request).suggestedMarket || 'n/a';
        this.props.context.telemetry.debug(
            `[${SpecificCountryRegionTrigger.name}] Customer country code set to: '${this.customerCountryCode}.'`
        );
    }

    public async validate(): Promise<boolean> {
        const retVal: boolean = this.props.config.proactiveOnSpecificLocation
            ? this.props.config.proactiveOnSpecificLocation.toLowerCase().indexOf(this.customerCountryCode.toLowerCase()) > -1
            : false;
        this.props.context.telemetry.debug(`[Chat][${SpecificCountryRegionTrigger.name}] Validation returning '${retVal}'.`);
        return retVal;
    }
    public getContextProvider(): TContextProvider {
        return () => {
            return {
                ...this.context,
                eCommerceCustIsProactiveChat: 'True',
                eCommerceCustProactiveCountryCode: this.props.config.proactiveOnSpecificLocation || '',
                eCommerceCustProactiveType: ProactiveChatNames.SpecificLocation
            };
        };
    }
    public getMessage(): string {
        // @TODO: Add message processing if needed
        return this.props.config.proactiveOnSpecificCountryRegionMessage || this.props.config.proactiveDefaultMessage;
    }
}

export default SpecificCountryRegionTrigger;
